import { useMutation } from 'react-query';
import { trpc } from '../../../../lib/trpc';

const useUpdateProductDocType = () => {
    return useMutation(
        async (params: { docId: number; document_type: number; document_subtype: number; entityId: number }) => {
            return trpc.ProductsApi.updateProductDocType.mutate(params);
        },
    );
};

export default useUpdateProductDocType;
